import { render, staticRenderFns } from "./leaveDetails.vue?vue&type=template&id=2dff41ee&scoped=true&"
import script from "./leaveDetails.vue?vue&type=script&lang=js&"
export * from "./leaveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff41ee",
  null
  
)

export default component.exports